import Vue from 'vue';
import Vuex from 'vuex';
import config from '@/config/config';
import keycloak from '@/store/keycloak';
import country from '@/store/country';
import menu from '@/store/menu';
import catalog from '@/store/catalog';
import access from '@/store/access';
import warning from '@/store/warning';

Vue.use(Vuex);
Vue.prototype.$config = config;
export default new Vuex.Store({
    modules: {
        keycloak,
        country,
        menu,
        catalog,
        access,
        warning,
    },
});